module.exports = __webpack_public_path__ + "static/img/PSS-80AS.8e79f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSS-80AS.png
// module id = AKgE
// module chunks = 1